// extracted by mini-css-extract-plugin
export default {"settingsNavigation":"content__settingsNavigation__c6fzS","back":"content__back__Cb1Bi","path":"content__path__ZE0Ox","sep":"content__sep__ul1As","current":"content__current__FQwr2"};